import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '../pages/HomePage'
import LoginPage from '../pages/LoginPage'
import GoodsListPage from '../pages/whaledge/goods/GoodsListPage'
import GoodsDetailPage from '../pages/whaledge/goods/GoodsDetailPage'
import GoodsTrashPage from '../pages/whaledge/goods/GoodsTrashPage'
import UserListPage from '../pages/whaledge/user/UserListPage'
import CategoryListPage from '../pages/whaledge/category/CategoryListPage'
import WaterMarkerListPage from '../pages/whaledge/watermarker/WaterMarkerListPage'
import MilkGoodsListPage from '../pages/milk/goods/MilkGoodsListPage'
import MilkGoodsDetailPage from '../pages/milk/goods/MilkGoodsDetailPage'
import MilkOrderListPage from '../pages/milk/order/MilkOrderListPage'
import MilkOrderDetailPage from '../pages/milk/order/MilkOrderDetailPage'
import MilkSchoolDetailPage from '../pages/milk/school/MilkSchoolDetailPage'
import MilkSchoolListPage from '../pages/milk/school/MilkSchoolListPage'
import MilkCategoryListPage from '../pages/milk/category/MilkCategoryListPage'
import MilkUserListPage from '../pages/milk/user/MilkUserListPage'
import MilkAreaListPage from '../pages/milk/area/MilkAreaListPage'
import MilkDepartmentListPage from '../pages/milk/department/MilkDepartmentListPage'

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', name: 'home', component: HomePage },
    { path: '/login', name: 'login', component: LoginPage },
    { path: '/home', name: 'home', component: HomePage },
    { path: '/user/list', name: 'userList', meta: { title: '用户列表' }, component: UserListPage },
    { path: '/goods/list', name: 'goodsList', meta: { title: '商品列表' }, component: GoodsListPage },
    { path: '/goods/detail/:remark', name: 'goodsDetail', meta: { showBack: true, title: '商品详情' }, component: GoodsDetailPage },
    { path: '/category/list', name: 'categoryList', meta: { showBack: true, title: '类目列表' }, component: CategoryListPage },
    { path: '/goods/trash', name: 'goodsTrash', meta: { title: '回收站' }, component: GoodsTrashPage },
    { path: '/parse/list', name: 'parseList', meta: { title: '去水印' }, component: WaterMarkerListPage },
    { path: '/milk/goods/list', name: 'milkGoodsList', meta: { title: '商品列表' }, component: MilkGoodsListPage },
    { path: '/milk/category/list', name: 'categoryList', meta: { showBack: true, title: '类目列表' }, component: MilkCategoryListPage },
    { path: '/milk/goods/detail/:remark', name: 'milkGoodsDetail', meta: { showBack: true, title: '商品详情' }, component: MilkGoodsDetailPage },
    { path: '/milk/order/list', name: 'milkOrderList', meta: { title: '订单列表' }, component: MilkOrderListPage },
    { path: '/milk/order/detail/:remark', name: 'milkOrderDetail', meta: { showBack: true, title: '订单详情' }, component: MilkOrderDetailPage },
    { path: '/milk/school/list', name: 'milkSchoolList', meta: { title: '学校列表' }, component: MilkSchoolListPage },
    { path: '/milk/school/detail/:remark', name: 'milkSchoolDetail', meta: { showBack: true, title: '学校详情' }, component: MilkSchoolDetailPage },
    { path: '/milk/user/list', name: 'milkUserList', meta: { title: '会员列表' }, component: MilkUserListPage },
    { path: '/milk/area/list', name: 'milkAreaList', meta: { title: '片区列表' }, component: MilkAreaListPage },
    { path: '/milk/department/list', name: 'milkDepartmentList', meta: { title: '单位列表' }, component: MilkDepartmentListPage }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js